import React from 'react';
import { Box, Hint, RawButton, Text, WarningIcon } from '@common-fe/common-fe';

import { FileStatus } from './FileManager.constants';

interface Props {
  fileStatus: FileStatus;
  isWarningIcon?: boolean;
  onSearchDuplicate: () => void;
}

const FileWarning: React.FC<Props> = ({ fileStatus, isWarningIcon, onSearchDuplicate }) => {
  if (fileStatus === FileStatus.Duplicate) {
    return (
      <Box align="end">
        <Hint
          testId="duplication-warning"
          hintAlign="vertical"
          hintWidth={220}
          hintElement={<WarningIcon data-testid="file-warning" />}
        >
          <Box overflow="auto">
            <Text size="small" weight={500} color="textOnColor" style={{ lineHeight: '18px' }}>
              This file has been identified as a duplicate or previous files.
            </Text>

            <RawButton data-testId="duplication-warning_filer-button" onClick={onSearchDuplicate}>
              <Text size="small" weight={400} color="navigationAccent" style={{ lineHeight: '18px' }}>
                Search for Duplicate Files
              </Text>
            </RawButton>
          </Box>
        </Hint>
      </Box>
    );
  }
  if (isWarningIcon) {
    return (
      <Box align="end">
        <WarningIcon data-testid="file-warning" />
      </Box>
    );
  }
  return null;
};

export default FileWarning;
